export enum EstadoCurso {
    Inscribible,
    NoInscribible,
    Trabajando,
    Inscrito,
}



// WEBPACK FOOTER //
// ./src/modulos/Horarios/TomaDeHorarios/componentes/Inscribir/Cursos/estadoCurso.ts